import { Component, computed, inject, Signal, ViewEncapsulation } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';

import { CelumButtonModule, CelumEmptyPageModule, CelumIconModule, CelumInputsModule, CelumMessageModule } from '@celum/common-components';
import { CreateFormat, Format, UpdateFormat } from '@celum/formats/domain';
import { AdminService, FORMAT_SERVICE, FormatFormService, FormatStore, SpecificationStore } from '@celum/formats/shared';
import { FnWrapperPipe } from '@celum/ng2base';

import { AbstractFormatViewDialog } from './abstract-format-view-dialog.directive';
import { FileExtensionsComponent } from './file-extensions/file-extensions.component';
import { LocalizedFieldComponent } from './localized-field/localized-field.component';
import { SpecParamsComponent } from './spec-params/spec-params.component';

@Component({
  selector: 'format-view',
  templateUrl: './format-view-dialog.component.html',
  styleUrls: ['./format-view-dialog.component.scss', './format-view-shared.scss'],
  providers: [FormatFormService, SpecificationStore],
  encapsulation: ViewEncapsulation.None, // custom style for `celum-form-field size="medium"`,
  host: { class: 'format-view' },
  imports: [
    FormsModule,
    MatCheckboxModule,
    MatDividerModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatSlideToggle,
    MatSelectModule,
    MatTooltipModule,
    ReactiveFormsModule,
    TranslateModule,
    CelumButtonModule,
    CelumEmptyPageModule,
    CelumIconModule,
    CelumInputsModule,
    CelumMessageModule,
    FnWrapperPipe,
    FileExtensionsComponent,
    LocalizedFieldComponent,
    SpecParamsComponent
  ]
})
export class FormatViewDialogComponent extends AbstractFormatViewDialog<Format, CreateFormat, UpdateFormat> {
  protected override readonly showHiddenFieldsStorageKey = 'formats-format-view-show-hidden-fields';
  protected override readonly logPrefix = 'FormatViewDialogComponent';

  protected override readonly formatFormService = inject(FormatFormService);
  protected override readonly formatService = inject(FORMAT_SERVICE);
  protected override readonly formatStore = inject(FormatStore);

  private adminService = inject(AdminService);
  protected override readonly isAdmin: Signal<boolean> = computed(() =>
    this.data.isAdminView !== undefined ? this.data.isAdminView : this.adminService.isAdmin()
  );
  protected override readonly showAutoImportExcludedToggle = false;

  protected override readonly dialogRef = inject(MatDialogRef<FormatViewDialogComponent>);
}
